'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module2Res5 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2Res5, _Component);

  function Module2Res5() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2Res5);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2Res5.__proto__ || (0, _getPrototypeOf2.default)(Module2Res5)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currPage: 0,
      title: 'Sample meal planner'
    }, _this.handleClickNext = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage + 1;
      _this.setState(obj);
    }, _this.handleClickPrev = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage - 1;
      _this.setState(obj);
    }, _this.handleOnClick = function (item, event) {
      event.preventDefault();
      console.log(event);
      console.log('CLICKED ' + item);
      var obj = _this.state;
      obj.currPage = item;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   *  User clicks on Next
   *  Increments the Page number and changes panel
   */


  /**
   *  User clicks on Previous
   *  Decrements the Page number and changes panel
   */


  /*
   * Quick link at the top to change the current page
   * to the selected page
   */


  (0, _createClass3.default)(Module2Res5, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, lg: 12, sm: 12, xs: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                'Module 2'
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Table,
              { bordered: true, striped: true, hover: true, responsive: true },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement('th', null),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Monday'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Tuesday'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Wednesday'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Thursday'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Friday'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Saturday'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Sunday'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Breakfast'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Weetbix with milk and tinned peaches'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Toast or English muffins (wholemeal) with vegemite and sliced cheese'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Porridge with chopped strawberries'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Boiled eggs on toast'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Weetbix with milk and chopped bananas'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Porridge with mixed berries'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Yoghurt and muesli with chopped kiwifruit'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Lunch'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Mini pizzas (ham, pineapple, capsicum and cheese) + apple slices'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Tuna and salad sandwich + kiwifruit'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Baked beans on toast + a mandarin'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Pasta and vegie salad + a bunch of grapes'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Left over cheesy vegetable frittata'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Banana and nut butter sandwich + carrot sticks'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '**Going to mum\'s on Sunday for lunch'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Dinner'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Chicken stir fry with brown rice'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Lamb chops with mashed potato and frozen peas/corn'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Grilled fish with potato, pumpkin and beans'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Cheesy vegetable frittata with carrots and broccoli'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Beef and vegetable casserole with brown rice'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    '**Going out for dinner'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Spaghetti bolognaise',
                    _react2.default.createElement('br', null),
                    'Fruit & ice cream'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Snacks'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Apple slices with nut butter'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Mandarin'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Strawberries'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Celery sticks and cottage cheese'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Carrot or capsicum sticks with hummus'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    'Natural yoghurt + mixed berries or tinned peaches'
                  ),
                  _react2.default.createElement('td', null)
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module2Res5;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module2Res5;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/2/Res5.js
// module id = 1242
// module chunks = 0